import React, { memo } from 'react';
import { useWindowSize } from 'common/components/useWindowSize';
import { CUSTOM_TRACKER_OPTIONS } from 'common/utils/facades/integrations-facade';
import { getDeviceType } from 'utils/environment';

function _getDeviceType() {
	const type = getDeviceType();
	switch (type) {
		case 'desktop':
			return 'web';
		case 'tablet':
			return 'tabletApp';
		case 'mobile':
			return 'mobile';
		default:
			return type;
	}
}

const variables = Object.values(CUSTOM_TRACKER_OPTIONS);

const CustomTracker = (props: { storyName: string; cardName: string; trackerUrl: string }) => {
	const windowSize = useWindowSize({ debounce: 300 });

	let url = decodeURIComponent(props.trackerUrl);

	variables.forEach(({ value }) => {
		let replacer;

		switch (value) {
			case '$STORY_NAME':
				replacer = props.storyName;
				break;
			case '$CARD_NAME':
				replacer = props.cardName;
				break;
			case '$PLATFORM':
				replacer = _getDeviceType();
				break;
			case '$REFERRER':
				replacer = document.referrer;
				break;
			case '$RESOLUTION':
				replacer = windowSize.innerWidth;
				break;
			default:
				break;
		}

		url = url.replace(value, replacer);
	});

	return <object type="text/html" data={url} width="0" height="0" aria-label="custom tracker" />;
};

export default memo(CustomTracker);
